import * as actionTypes from "./configurations/actionTypes";
import { trackSimpleEvent } from "../../helpers/reduxBeacon";

const gaEventsMap = {
  ...trackSimpleEvent(actionTypes.SET_QUANTITY)
};

export default gaEventsMap;
